module.exports = __webpack_public_path__ + "static/the-lancashire-hotpots-jamboree-header-70908ac81d735d30fe088c968e8d156e.jpg";